var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.props),function(prop,idx){return _c('div',{key:idx,staticClass:"wrapper"},[_c('TaskFormField',{attrs:{"prop":prop,"custprop":_vm.custprops[prop.pid]}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }